import { Button, Stack } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RouteConstants } from '../../navigation/navigation-types'

const AccessDenied: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Stack width='100vw' height='100vh' alignItems='center' justifyContent='center' spacing={2}>
      <h2>
        Je nám líto, ale nemáte dostatečná oprávnění pro přístup na tuto stránku.
      </h2>
      <Button variant='contained' onClick={() => navigate(RouteConstants.events)}>
        Přejít na plánování událostí
      </Button>
      <Button variant='contained' onClick={() => navigate(RouteConstants.settings)}>
        Přejít ma profil
      </Button>
    </Stack>
  )
}

export default AccessDenied